export default function TimeSlot({
  label,
  counter,
}: {
  label: string;
  counter: number;
}) {
  const with_leading_0 = ('00' + counter.toString()).slice(-2);
  return (
    <li className='flex flex-col text-center'>
      <span className='block text-2xl sm:text-3xl xl:text-4xl'>{with_leading_0}</span>
      <span className='text-xs'>{label}</span>
    </li>
  );
}
